precision highp float;

uniform float time;
varying float vAlpha;
varying float vRandom;

float hash(vec2 p) {
  return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453123);
}

float noise(vec2 p){
  vec2 i = floor(p);
  vec2 f = fract(p);

  float a = hash(i);
  float b = hash(i + vec2(1.0, 0.0));
  float c = hash(i + vec2(0.0, 1.0));
  float d = hash(i + vec2(1.0, 1.0));

  vec2 u = f * f * (3.0 - 2.0 * f);

  return mix(a, b, u.x) + (c - a) * u.y * (1.0 - u.x) + (d - b) * u.x * u.y;
}

float fbm(vec2 p){
  float v = 0.0;
  float amp = 0.5;
  for(int i = 0; i < 3; i++){
    v += amp * noise(p);
    p *= 2.0;
    amp *= 0.5;
  }
  return v;
}

float sdBox(vec2 p, vec2 b) {
  vec2 d = abs(p) - b;
  return length(max(d, 0.0)) + min(max(d.x, d.y), 0.0);
}

float getDigitMask(vec2 p, float isOne) {
  float aa = fwidth(p.x) * 1.5 + 0.001;

  float stem   = 1.0 - smoothstep(0.055 - aa, 0.055 + aa, abs(p.x));
  float height = 1.0 - smoothstep(0.36  - aa, 0.36  + aa, abs(p.y));
  float base   = 1.0 - smoothstep(0.0   - aa, 0.05  + aa, length(p - vec2(0.0, -0.30)));
  float oneMask = clamp(max(stem * height, base * 0.7), 0.0, 1.0);

  float outer   = 1.0 - smoothstep(0.0 - aa, 0.01 + aa, sdBox(p, vec2(0.18, 0.33)));
  float inner   = 1.0 - smoothstep(0.0 - aa, 0.01 + aa, sdBox(p, vec2(0.09, 0.21)));
  float ring    = clamp(outer - inner, 0.0, 1.0);
  float roundTopBottom = 1.0 - smoothstep(0.20, 0.40, abs(p.y));
  float zeroMask = ring * (0.85 + 0.15 * roundTopBottom);

  return mix(zeroMask, oneMask, isOne);
}

void main() {
  vec2 uv = gl_PointCoord - 0.5;

  float rnd = fract(vRandom * 43758.5453);
  float isOne = step(0.5, rnd);

  float charMask = getDigitMask(uv, isOne);

  float glow = 1.0 - smoothstep(0.18, 0.48, length(uv));
  float glyphGlow = glow * 0.14;

  vec2 ncoord = uv * 3.0;
  float n = fbm(ncoord + vec2(time * 0.05 + vRandom * 10.0, time * 0.02));

  float shimmer = 0.94 + 0.06 * sin(time * 2.2 + vRandom * 11.0 + uv.y * 8.0);

  float alpha = charMask * vAlpha;
  alpha *= (0.92 + 0.08 * n);
  alpha *= shimmer;

  if (alpha < 0.01) {
    discard;
  }

  vec3 dark = vec3(0.04, 0.06, 0.08);
  vec3 light = vec3(0.48, 0.58, 0.68);
  vec3 glowCol = vec3(0.75, 0.88, 1.0);

  vec3 col = mix(dark, light, rnd * 0.7 + 0.15);
  col += glowCol * glyphGlow;
  col *= 0.96 + 0.08 * n;

  gl_FragColor = vec4(col, alpha);
}